/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { ApiBaseService } from '../api-base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { configurationCaptchaGet } from '../fn/configuration/configuration-captcha-get';
import { ConfigurationCaptchaGet$Params } from '../fn/configuration/configuration-captcha-get';
import { RecaptchaBaseConfig } from '../models/recaptcha-base-config';

@Injectable({ providedIn: 'root' })
export class ConfigurationHttpService extends ApiBaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `configurationCaptchaGet()` */
  static readonly ConfigurationCaptchaGetPath = '/Configuration/captcha';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `configurationCaptchaGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  configurationCaptchaGet$Response(
    params?: ConfigurationCaptchaGet$Params,
    context?: HttpContext,
  ): Observable<StrictHttpResponse<RecaptchaBaseConfig>> {
    const obs = configurationCaptchaGet(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `configurationCaptchaGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  configurationCaptchaGet(
    params?: ConfigurationCaptchaGet$Params,
    context?: HttpContext,
  ): Observable<RecaptchaBaseConfig> {
    const resp = this.configurationCaptchaGet$Response(params, context);
    return resp.pipe(map((r: StrictHttpResponse<RecaptchaBaseConfig>): RecaptchaBaseConfig => r.body));
  }
}
